module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-rc.48-71.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.0-rc.48.md
// module id = 487
// module chunks = 368